module.exports = __webpack_public_path__ + "static/img/fkzt3.4117682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/fkzt3.png
// module id = 320
// module chunks = 0